// App.js
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Section from "./components/Section";
import { api } from "./lib/api";

export default function App() {
  // Your 4-in-1 IDs (keep the same, or load from env/config)
  const ids = {
    i19if: "3",
    boxning: "4",
    ol: "7",
    skidor: "6",
    skidskytte: "5",
  };

  const [meta, setMeta] = useState({});
  const [state, setState] = useState({ loading: true, error: null });

  useEffect(() => {
    (async () => {
      try {
        const [i19if, boxning, ol, skidor, skidskytte] = await Promise.all([
          api.websiteMeta(ids.i19if),
          api.websiteMeta(ids.boxning),
          api.websiteMeta(ids.ol),
          api.websiteMeta(ids.skidor),
          api.websiteMeta(ids.skidskytte),
        ]);
        setMeta({ i19if, boxning, ol, skidor, skidskytte });
        setState({ loading: false, error: null });
      } catch (e) {
        setState({ loading: false, error: e.message || "Network error" });
      }
    })();
  }, []);

  if (state.loading) return <div className="p-8">Laddar…</div>;
  if (state.error) return <div className="p-8 text-red-600">Fel: {state.error}</div>;

  return (
    <Router>
      <Routes>
        <Route
          path="/*"
          element={
            <Section
              key="i19if"
              basePath=""
              sectionText="I19 IF"
              websiteId={ids.i19if}
              siteMeta={meta.i19if}
            />
          }
        />
        <Route
          path="/boxning/*"
          element={
            <Section
              key="boxning"
              basePath="/boxning"
              sectionText="I19 IF Boxning"
              websiteId={ids.boxning}
              siteMeta={meta.boxning}
            />
          }
        />
        <Route
          path="/ol-ol-skytte/*"
          element={
            <Section
              key="ol"
              basePath="/ol-ol-skytte"
              sectionText="I19 IF OL/OL-Skytte"
              websiteId={ids.ol}
              siteMeta={meta.ol}
            />
          }
        />
        <Route
          path="/skidor/*"
          element={
            <Section
              key="skidor"
              basePath="/skidor"
              sectionText="I19 IF Skidor"
              websiteId={ids.skidor}
              siteMeta={meta.skidor}
            />
          }
        />
        <Route
          path="/skidskytte/*"
          element={
            <Section
              key="skidskytte"
              basePath="/skidskytte"
              sectionText="I19 IF Skidskytte"
              websiteId={ids.skidskytte}
              siteMeta={meta.skidskytte}
            />
          }
        />
      </Routes>
    </Router>
  );
}
